/**
 * # Clipboard
 * Clipboard constructor for https://clipboardjs.com/
 */
export const ClipboardProvider = {
  provide: 'Clipboard',
  useValue: require('clipboard'),
};
